import React, { ReactElement } from 'react';
import CurrentUserDetail from '../../../model/currentuser/CurrentUserDetail';
import { ForbiddenPage } from '../../../page';
import UserRole from '../../../model/currentuser/UserRole';

interface Props {
  pouzivatel: CurrentUserDetail;
  children: ReactElement;
  allowForRoles?: Array<UserRole>;
  additionalCheck?: boolean;
  hasOpravneniePracovneKroky?: boolean | null;
}

const isAuthorized = (
  allowForRoles: Array<UserRole>,
  user: CurrentUserDetail,
): boolean => {
  const userRoles = user == null ? [] : user.roles;
  if (!allowForRoles) {
    return true;
  }
  if (!userRoles || userRoles.length === 0 || allowForRoles.length === 0) {
    return false;
  }
  return userRoles.some(role => allowForRoles.includes(role));
};

const hasPracovneKroky = (hasOpravneniePracovneKroky: boolean): boolean => {
  if (hasOpravneniePracovneKroky === null) {
    return true;
  }
  return hasOpravneniePracovneKroky;
};

const SecuredPageComponent = ({
  children,
  allowForRoles,
  pouzivatel,
  additionalCheck = true,
  hasOpravneniePracovneKroky = null,
}: Props): ReactElement => {
  if (!isAuthorized(allowForRoles, pouzivatel) || !additionalCheck || !hasPracovneKroky(hasOpravneniePracovneKroky)) {
    if (hasOpravneniePracovneKroky === null) {
      return <ForbiddenPage />;
    }
    return (
      <ForbiddenPage />
    );
  }

  return children;
};

export default SecuredPageComponent;
